// extracted by mini-css-extract-plugin
module.exports = {"container":"order-form-header-module__container___2xCEt","guardantLogo":"order-form-header-module__guardantLogo___3yD6-","title":"order-form-header-module__title___3mq8t"};